// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"119":"view-agent-request","561":"kyc-signups","798":"payment-wallet","966":"dashboard"}[chunkId] + "." + {"119":"33633323","561":"4fc9e211","798":"0eb2dbae","966":"c26706d4"}[chunkId] + ".css";
};